import { STORES_APP_DEF_ID } from 'config/apps';
import { endpoints } from './endpoints';
import { Namespace } from '@wix/ambassador-metasite-api-v1-meta-site/types';
import { useAppStore } from 'stores/appStore';
import { mapperUtils } from 'utils/mappers';
import { V1TenantType } from '@wix/ambassador-apps-v1-app-instance/types';
import { TEMPLATE_META_SITE_ID } from 'config/consts';
import { localeUtils } from 'utils/locale';
import { biEvents } from './bi-events';
import { assertString } from 'utils/invariants';

const createMetaSite = async () => {
  const { metaSiteId } = useAppStore.getState();
  if (!metaSiteId) {
    const response = await endpoints.createMetaSite({
      namespace: Namespace.HTML_DRAFT,
      name: 'merch-maker-site',
    });
    useAppStore.setState({ metaSiteId: response.metaSite?.metaSiteId });
  }
};

const uploadSiteMedia = async () => {
  const { localFile: media, mediaUrl } = useAppStore.getState();
  if (media && !mediaUrl) {
    const response = await endpoints.uploadSiteMedia({ media });
    useAppStore.setState({ mediaUrl: response.url });
  }
};

const generateMockups = async () => {
  const { mediaUrl, selectedProducts } = useAppStore.getState();
  if (mediaUrl) {
    await endpoints.generateMockups({
      mockups: mapperUtils.productsWithMediaToMockups(selectedProducts, mediaUrl),
    });
  }
};

const attachSiteTemplate = async () => {
  await endpoints.attachSiteTemplate({ templateMetaSiteId: TEMPLATE_META_SITE_ID });
};

const installSiteApps = async () => {
  const { metaSiteId } = useAppStore.getState();
  assertString(metaSiteId);
  const appInstances = [{ appDefId: STORES_APP_DEF_ID }];
  await endpoints.installSiteApps({ appInstances, tenant: { id: metaSiteId, tenantType: V1TenantType.SITE } });
  biEvents.msidCreated({ msid: metaSiteId });
};

const fetchSiteUrl = async () => {
  const response = await endpoints.getSiteUrls({});
  useAppStore.setState({ siteUrl: response.metaSiteUrls?.primary?.url });
};

const addStoreProducts = async () => {
  const { selectedProducts, mediaUrl } = useAppStore.getState();
  const productReferences = selectedProducts.map((productId) => ({ productId, options: { imageUrl: mediaUrl } }));
  await endpoints.addStoreProducts({ productReferences });
};

const makeProductsVisible = async () => {
  const { selectedProducts } = useAppStore.getState();
  await endpoints.makeProductsVisible({ productsCount: selectedProducts.length });
};

const updateSiteName = async () => {
  const { storeName } = useAppStore.getState();
  await endpoints.updateSiteSettings({ siteDisplayName: storeName });
};

const injectSiteNameComponent = async () => {
  const { storeName, selectedCategory } = useAppStore.getState();
  const categoryName = localeUtils.getI18n().t(`select-category-step.options.item.title.${selectedCategory}`);
  await endpoints.injectComponentCore({
    pageId: 'masterPage',
    componentId: 'comp-leml8lvx',
    targets: {
      Tote: storeName ?? 'My Store Name',
    },
  });
  await endpoints.injectComponentCore({
    pageId: 'masterPage',
    componentId: 'comp-jbw7ztjj',
    targets: {
      'Funky Printed Bags': categoryName,
    },
  });
};

export const actions = {
  createMetaSite,
  uploadSiteMedia,
  generateMockups,
  attachSiteTemplate,
  installSiteApps,
  fetchSiteUrl,
  addStoreProducts,
  makeProductsVisible,
  updateSiteName,
  injectSiteNameComponent,
};
